import { send } from 'server';

export const submitAdvancedDialog = ({ actionId, buttonId, windowSessionId, failedHTCMDs }) => send({
    ID: 35598,
    responses: [35599, 35600],
    description: 'Submit Advanced Dialog Request',
    actionId,
    buttonId,
    windowSessionId,
    failedHTCMDs
});
